<template>
  <section class="max-w-3xl mx-auto px-4 py-10 space-y-8">
    <header class="space-y-2">
      <h1 class="text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-gray-100">Contact Us</h1>
      <p class="text-sm text-gray-600 dark:text-gray-300">
        If you find a timing issue, content mistake, or want to suggest an improvement, contact us.
      </p>
    </header>

    <div class="space-y-6 text-sm text-gray-700 dark:text-gray-300 leading-6">
      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">Email</h2>
        <p>
          Reach us at:
          <a href="mailto:contact@rozay.today" class="underline hover:no-underline dark:text-gray-200">contact@rozay.today</a>
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">What to Include</h2>
        <ul class="list-disc pl-5 space-y-1">
          <li>Your city name (for timing feedback)</li>
          <li>The page URL where you found the issue</li>
          <li>A short description of the correction or suggestion</li>
        </ul>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">Response Time</h2>
        <p>We try to review messages as soon as possible, but response time may vary during Ramadan.</p>
      </section>
    </div>
  </section>
</template>
